import React from "react";

import AuthContextProvider from "./AuthContext";
import ExcelContextProvider from "./ExcelContext";
import AgentContextProvider from "./AgentContext";
import ClientContextProvider from "./ClientContext";
import FeedbackContextProvider from "./FeedbackContext";

const ContextProvider = (props) => {
  return (
    <AuthContextProvider>
      <ExcelContextProvider>
        <FeedbackContextProvider>
          <AgentContextProvider>
            <ClientContextProvider>{props.children}</ClientContextProvider>
          </AgentContextProvider>
        </FeedbackContextProvider>
      </ExcelContextProvider>
    </AuthContextProvider>
  );
};

export default ContextProvider;
